export default "__VITE_ASSET__49ce414f__"